import { render, staticRenderFns } from "./RecognitionList.vue?vue&type=template&id=0f0f6f13&scoped=true"
import script from "./RecognitionList.vue?vue&type=script&lang=js"
export * from "./RecognitionList.vue?vue&type=script&lang=js"
import style0 from "./RecognitionList.vue?vue&type=style&index=0&id=0f0f6f13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f6f13",
  null
  
)

export default component.exports